import { Card, styled } from '@mui/material'

export const CardWrapper = styled(Card)(() => ({
  display: 'flex',
  flexDirection: 'column'
}))